/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet'
import {useStaticQuery, graphql, withPrefix} from 'gatsby'

function SEO({
	description,
	lang,
	meta,
	keywords,
	title,
	image,
	imageWidth,
	imageHeight,
	//imageSecureUrl,
	ogType,
	twitterCard,
	structuredData,
	canonicalpath,
}) {
	const {site} = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						title
						description
						author
						siteUrl
						twitterHandle
						themeColor
						themeBGColor
						imgUrl
						imgWidth
						imgHeight
					}
				}
			}
		`,
	)
	var metaTitleTemplate = "%s | "+site.siteMetadata.title
	const metaDescription = description || site.siteMetadata.description
	const metaImage = image || site.siteMetadata.imgUrl
	const metaImageHeight = {}
	const metaImageWidth = {}
	const metaSiteUrl = {}

	if (canonicalpath !== undefined) {
		if (canonicalpath.substring(canonicalpath.length-1) !== "/") {
			// Add tailing slash to match sitemap
			canonicalpath = canonicalpath + "/";
		}

		if (structuredData !== undefined) {
			if (structuredData.hasOwnProperty("offers")) {
				structuredData.offers.url = site.siteMetadata.siteUrl+canonicalpath
			}
		}
		metaSiteUrl.property = `og:url`
		metaSiteUrl.content = site.siteMetadata.siteUrl+canonicalpath
	}
	if(image===undefined) {
		//use default
		metaImageWidth.property = `og:image:width`
		metaImageWidth.content = site.siteMetadata.imgWidth
		metaImageHeight.property = `og:image:height`
		metaImageHeight.content = site.siteMetadata.imgHeight
	}else {
		if(imageWidth && imageHeight) {
			metaImageWidth.property = `og:image:width`
			metaImageWidth.content = imageWidth
			metaImageHeight.property = `og:image:height`
			metaImageHeight.content = imageHeight
		}
	}
	if (title === site.siteMetadata.title || title === "") {
		metaTitleTemplate = site.siteMetadata.title
		title = site.siteMetadata.title
	}
	return (
		<Helmet
			htmlAttributes={{
				lang,
			}}
			title={title}
			titleTemplate={metaTitleTemplate}
			meta={[
				{
					name: `description`,
					content: metaDescription,
				},
				{
					property: `og:site_name`,
					content: site.siteMetadata.title,
				},
				{
					property: `og:title`,
					content: title,
				},
				{
					property: `og:description`,
					content: metaDescription,
				},
				metaSiteUrl,
				{
					property: `og:type`,
					content: ogType,
				},
				{
					property: `og:image`,
					content: metaImage,
				},
				metaImageHeight,
				metaImageWidth,
				{
					property: `og:image:alt`,
					content: title,
				},
				{
					property: `og:image:secure_url`,
					content: metaImage,
				},
				{
					name: `twitter:card`,
					content: twitterCard,
				},
				{
					name: `twitter:creator`,
					content: site.siteMetadata.author,
				},
				{
					name: `twitter:image`,
					content: metaImage,
				},
				{
					name: `twitter:image:alt`,
					content: title
				},
				{
					name: `twitter:site`,
					content: site.siteMetadata.twitterHandle
				},
				{
					name: `twitter:title`,
					content: title,
				},
				{
					name: `twitter:description`,
					content: metaDescription,
				},
				{
					name: 'msapplication-TileColor',
					content: site.siteMetadata.themeBGColor
				},
				{	name: 'theme-color',
					content: site.siteMetadata.themeColor
				},
			]
			.concat(
				keywords.length > 0
				? {
					name: `keywords`,
					content: keywords.join(`, `),
				}
				: [],
			)
			.concat(meta)}
		>
			{(canonicalpath !== undefined) && (
				<link
					rel="canonical"
					key={site.siteMetadata.siteUrl+canonicalpath}
					href={site.siteMetadata.siteUrl+canonicalpath}
				/>
			)}
			{structuredData && (
				<script type="application/ld+json">
					{JSON.stringify(structuredData)}
				</script>
			)}
			<link
				rel="apple-touch-icon"
				sizes="180x180"
				href={withPrefix('/favicons/apple-touch-icon.png')}
			/>
			<link
				rel="icon"
				type="image/png"
				sizes="32x32"
				href={withPrefix('/favicons/favicon-32x32.png')}
			/>
			<link
				rel="icon"
				type="image/png"
				sizes="16x16"
				href={withPrefix('/favicons/favicon-16x16.png')}
			/>
		</Helmet>
	)
}

SEO.defaultProps = {
	lang: `en`,
	meta: [],
	keywords: [],
	ogType: `website`,
	twitterCard: `summary_large_image`,
}

SEO.propTypes = {
	description: PropTypes.string,
	lang: PropTypes.string,
	meta: PropTypes.array,
	keywords: PropTypes.arrayOf(PropTypes.string),
	title: PropTypes.string.isRequired,
	ogType: PropTypes.string,
	image: PropTypes.string,
	imageWidth: PropTypes.number,
	imageHeight: PropTypes.number,
	twitterCard: PropTypes.string,
	canonicalpath: PropTypes.string,
}

export default SEO
